module.exports = __webpack_public_path__ + "static/media/landingPagePreview.4298ab09.svg";